import { render, staticRenderFns } from "./DataTypes.vue?vue&type=template&id=634bf71d"
import script from "./DataTypes.vue?vue&type=script&lang=js"
export * from "./DataTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports